import { useState } from 'react';
import { COPY_ERROR_MESSAGE, PROMO_RESET_TIMEOUT } from '../consts/promotionalOfferConsts';

export const useCopyCode = (onCopyCode?: (text: string) => Promise<void>) => {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = async (couponCode: string) => {
    try {
      setCopied(true);
      await onCopyCode?.(couponCode);

      setTimeout(() => setCopied(false), PROMO_RESET_TIMEOUT);
    } catch (err) {
      console.error(COPY_ERROR_MESSAGE, err);
    }
  };

  return { copied, handleCopyCode };
};

